module.exports = __webpack_public_path__ + "static/media/no-internet-connection.c67a32ab.svg";